<template>
    <div>
        <shareItem v-show="$route.query && $route.query.sharetype =='browser'" :dlurl="dlurl" pageCode="5010202" v-isNoAppShare/>
        <div class="brand-list-head-box"></div>
        <div class="brand-list-head">
            <div class="left">
                <img src="@/assets/image/back.png" alt class="back" @click="goBack" />
                <img :src="brandData.logoImageInfo&&brandData.logoImageInfo.imageUrl" alt class="lgo" />
                <span>{{brandData.brandName}}</span>
            </div>
            <div class="right">
                <img src="@/assets/brand/search_mark@2x.png" alt @click="routeToSearch" />
								<img v-show="brandData.userFollow == 1" src="@/assets/brand/like.png" alt @click="followToggleClick" />
								<img v-show="brandData.userFollow == 2" src="@/assets/brand/like-active.png" alt @click="followToggleClick" />
                <img src="@/assets/image/brandico.png" alt class="share" @click="onJupmToAppShare" />
            </div>
        </div>
        <div class="brand-list-remend">
            <div class="remend-title">
                <span>新品推荐</span>
                <span class="remend-title-btn" v-if="brandData.branchList && brandData.branchList.length == 1" @click="onJumpToBranch(brandData.branchList[0].id)">进店</span>
            </div>
            <div class="remend-goods-wrap">
                <div class="remend-goods" v-for="(goods, index) in goodsList" :key="index" @click="onJumpToGoodsDetail(goods)">
                    <van-image class="goods-pic" :src="goods.indexImage&&goods.indexImage.imageUrl" />
                    <img v-if="goods.type=='DISCOVER'" class="remend-goods-logo" src="../../assets/brand/wenwen.png"/>
                    <p class="goods-price">
                        <span>￥{{goods.price}}</span>
                        <span>￥{{goods.markingPrice}}</span>
                    </p>
                    <div class="goods-btn">{{funPrice(goods)}}</div>
                </div>
            </div>
        </div>
        <List @getProduct="getProduct" @getBrand="getBrand" :logoId="Number($route.query.id)" />
    </div>
</template>

<script>
import http from "@/utils/axios";
import List from './components/brand_list';
import shareItem from "@/views/shareDiscovery/components/shareBtn";
import utils from "@/utils/common";
export default {
    data() {
        return {
            dlurl:'',
            goodsList: [],
            brandData: { userFollow: 1 }
        }
    },
    methods: {
        goBack() {
            this.$minicode.show({pageCode:'5010202',pageQueryParam:this.$route.query});
            utils.goBack();
        },
        onJupmToAppShare() {
            this.$minicode.show({pageCode:'5010202',pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
            utils.nativeMethod({tm:4070101,tp: { branchLogoId:this.$route.query.id}})
        },
        getProduct(val) {
            this.goodsList = val;
        },
        getBrand(val) {
            this.brandData = val;
        },
        onJumpToBranch(id) {
            let url=`${window.location.origin}/h5user/brandindex?id=${id}`;
            // this.$router.push({
            //     name: "brandindex",
            //     query: { id },
            // });
            let obj = {branchId:parseInt(id)};
            utils.jumpToNewPage({
                url: url,
                noTitle: "0",
                action:{tm:"4090100",tp:obj}
            });
        },
        onJumpToGoodsDetail(item) {
            switch(item.type) {
                case 'PRODUCT': 
                    let url=`${window.location.origin}/h5user/commoditydetails?id=${item.refId}`;
                    var obj = {goodsId:parseInt(item.refId)};
                    utils.jumpToNewPage({
                        url: url,
                        noTitle: "0",
                        action:{tm:"4030100",tp:obj}
                    });
                    // this.$router.push({
                    //     path: "/commoditydetails",
                    //     query: { id: item.refId }
                    // });
                    break;
                case 'DISCOVER':
                    this.$router.push({
                        name: 'discoverUserDetails', 
                        query: { discoverId: item.refId}
                    })
                break;
            }
        },
        routeToSearch() {
            utils.jumpToNewPage({
                url: window.location.origin +'/h5user/searchNew?searchType=PRODUCT&searchValue='+(this.brandData.brandName||''),
                noTitle: '0',
            });
        },
        funPrice(item) {
            if (item.price == item.markingPrice) {
                return "暂无折扣";
            } else {
                var str = (item.price / item.markingPrice * 10).toFixed(1);
                return "低至" + str + "折";
            }
        },
        followToggleClick() {
            http({
                url: '/order/user/branch/followBranchLogo/' + this.brandData.id,
                method: 'put'
            }).then(data => {
                const state = this.brandData.userFollow = this.brandData.userFollow == 1 ? 2 : 1
                this.$toast(state == 2 ? '关注成功' : '取消关注成功')
            })
        }
    },
    components: {
        List,
        shareItem
    },
    created(){
        utils.nativeMethod({tm:'1000003',tp:{noTitle:"1"}});   
    }
}
</script>

<style lang="less" scoped>
.brand-list-head-box {
  height: 92px;
}
.brand-list-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px 20px 20px;
    background-color: #fff;
    height: 92px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    box-sizing: border-box;
    border-bottom: 2px solid #f5f5f5;
    img {
        width: 44px;
        height: 44px;
    }
    .left {
        display: flex;
        align-items: center;
        font-size: 0;
        .lgo {
            width: 78px;
            height: 52px;
            margin: 0 20px;
            object-fit: cover;
        }
        span {
            display: inline-block;
            font-size: 32px;
            font-weight: 500;
            max-width: 340px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            padding-top: 2px;
        }
    }
    .right {
        display: flex;
        align-items: center;
        img:not(:last-child) {
            margin-right: 30px;
        }
    }
}
.brand-list-remend {
    // height: 398px;

    .remend-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
        line-height: 80px;
        font-size: 28px;
        color: #fff;
        font-weight: 500;
        padding: 0 40px;
        background:linear-gradient(90deg,rgba(254,207,77,1) 0%,rgba(250,125,153,1) 100%);
    }
    .remend-title-btn {
         width: 58px;
        height: 34px;
        border-radius: 10px;
        background-color: #fff;
        color: #F8A651;
        font-size: 20px;
        line-height: 34px;
        text-align: center;
        font-weight:500;
        padding-top: 3px;
        box-sizing: border-box;
    }
    .remend-goods-wrap {
        display: flex;
        margin: 20px 30px 28px;
        overflow-x: scroll;
        &::-webkit-scrollbar {display:none}
        .remend-goods:first-child {
            margin-left: 0;
        }
        .remend-goods {
            width: 180px;
            padding: 10px 10px 18px;
            box-sizing: border-box;
            background-color: #fff;
            margin-left: 10px;
            position: relative;

            .remend-goods-logo {
                width: 57px;
                height: 30px;
                position: absolute;
                top: 10px;
                right: 11px;
                z-index: 5;
            }
            
            .goods-pic {
                width: 160px;
                height: 160px;
            }
            .goods-price {
                height: 33px;
                font-size: 24px;
                color: #E83636;
                line-height: 33px;
                margin: 10px 0 9px;
                span:last-child{
                    margin-left: 10px;
                    color: #CCCCCC;
                    text-decoration: line-through;
                }
            }
            .goods-btn {
                height: 33px;
                background-color: #FFEDEE;
                border-radius: 17px;
                color: #ED3939;
                font-size: 20px;
                line-height: 33px;
                text-align: center;
                padding-top: 3px;
                box-sizing: border-box;
            }
        }
    }
}

</style>